/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : menuStyleUtils.ts
// 메인 메뉴 표시방식(좌측 사이드바 / 상단 메가메뉴) 유틸리티 함수
//  - MenuStyle : 메뉴 표시방식 타입 정의
//  - getStoredMenuStyle : 저장된 메뉴 표시방식 조회
//  - setStoredMenuStyle : 메뉴 표시방식 저장 + 반영(변경 이벤트 발생)
/////////////////////////////////////////////////////////////////////////////////////////////////////////

export type MenuStyle = 'sidebar' | 'topmenu';

const MENU_STYLE_STORAGE_KEY = 'menuStyle';

/** 유틸명 : getStoredMenuStyle()
 ** 저장된 메뉴 표시방식을 가져옵니다. 저장된 값이 없으면 'sidebar'(기존 방식).
 ** 저장소 : localStorage
 * @returns 'sidebar' | 'topmenu'
 */
export const getStoredMenuStyle = (): MenuStyle => {
  try {
    const stored = localStorage.getItem(MENU_STYLE_STORAGE_KEY);
    return stored === 'topmenu' ? 'topmenu' : 'sidebar';
  } catch (error) {
    console.error('Failed to get menu style:', error);
    return 'sidebar';
  }
};

/** 유틸명 : setStoredMenuStyle()
 ** 메뉴 표시방식을 저장하고, 변경 이벤트를 발생시킵니다(mainFrame 등에서 구독).
 * @param style 저장할 메뉴 표시방식
 ** 저장소 : localStorage
 */
export const setStoredMenuStyle = (style: MenuStyle): void => {
  try {
    localStorage.setItem(MENU_STYLE_STORAGE_KEY, style);
    window.dispatchEvent(new CustomEvent('menuStyleChanged', { detail: style }));
  } catch (error) {
    console.error('Failed to save menu style:', error);
  }
};
